import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e89f152"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "AiMonitoringRegionModal",
  ref: "modalElement",
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "modal-title fs-5" }, "Perímetro de monitoramento IA", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-body-secondary"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Fechar"
}, null, -1))
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Toque ou clique sobre a imagem para marcar os pontos. O alerta será disparado quando qualquer parte da pessoa tocar a área destacada. ", -1))
const _hoisted_10 = {
  ref: "stage",
  class: "region-stage"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "region-placeholder"
}
const _hoisted_13 = {
  key: 0,
  class: "spinner-border text-light",
  role: "status"
}
const _hoisted_14 = {
  key: 1,
  class: "flaticon-video-camera-1"
}
const _hoisted_15 = ["points"]
const _hoisted_16 = ["points"]
const _hoisted_17 = ["cx", "cy", "onPointerdown"]
const _hoisted_18 = { class: "region-status mt-3" }
const _hoisted_19 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_20 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_21 = {
  key: 2,
  class: "badge bg-warning text-dark"
}
const _hoisted_22 = { class: "d-flex flex-wrap gap-2 mt-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, "Cancelar", -1))
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            (_ctx.camera)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.camera.name), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_ctx.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["alert mb-3", _ctx.messageType === 'error' ? 'alert-danger' : 'alert-success'])
              }, _toDisplayString(_ctx.message), 3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("video", {
              ref: "previewVideo",
              class: "region-media",
              autoplay: "",
              muted: "",
              playsinline: "",
              onLoadedmetadata: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleVideoMetadata && _ctx.handleVideoMetadata(...args))),
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args)))
            }, null, 544), [
              [_vShow, _ctx.mediaMode === 'video']
            ]),
            (_ctx.imageSource)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  ref: "previewImage",
                  class: "region-media",
                  src: _ctx.imageSource,
                  alt: `Preview da câmera ${_ctx.camera ? _ctx.camera.name : ''}`,
                  onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImageLoad && _ctx.handleImageLoad(...args))),
                  onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_11)), [
                  [_vShow, _ctx.mediaMode === 'image']
                ])
              : _createCommentVNode("", true),
            (!_ctx.mediaReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.loadingMedia)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                    : (_openBlock(), _createElementBlock("i", _hoisted_14)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.loadingMedia ? 'Carregando imagem da câmera...' : 'Preview indisponível para desenhar'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.mediaReady)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 2,
                  ref: "overlay",
                  class: "region-overlay",
                  style: _normalizeStyle(_ctx.overlayStyle),
                  viewBox: "0 0 1 1",
                  preserveAspectRatio: "none",
                  onPointerdown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addPoint && _ctx.addPoint(...args)))
                }, [
                  (_ctx.closed && _ctx.points.length >= 3)
                    ? (_openBlock(), _createElementBlock("polygon", {
                        key: 0,
                        points: _ctx.svgPoints,
                        class: "region-polygon"
                      }, null, 8, _hoisted_15))
                    : (_ctx.points.length)
                      ? (_openBlock(), _createElementBlock("polyline", {
                          key: 1,
                          points: _ctx.svgPoints,
                          class: "region-polyline"
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.points, (point, index) => {
                    return (_openBlock(), _createElementBlock("circle", {
                      key: index,
                      cx: point.x,
                      cy: point.y,
                      r: "0.012",
                      class: "region-handle",
                      "vector-effect": "non-scaling-stroke",
                      onPointerdown: _withModifiers(($event: any) => (_ctx.startDragging(index, $event)), ["stop","prevent"])
                    }, null, 40, _hoisted_17))
                  }), 128))
                ], 36))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.fullFrameSelected)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Quadro inteiro selecionado"))
              : (_ctx.closed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Perímetro fechado com " + _toDisplayString(_ctx.points.length) + " pontos", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.points.length) + " ponto(s) — mínimo de 3", 1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              disabled: !_ctx.points.length,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.undoPoint && _ctx.undoPoint(...args)))
            }, " Desfazer ponto ", 8, _hoisted_23),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              disabled: !_ctx.points.length,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redraw && _ctx.redraw(...args)))
            }, " Redesenhar ", 8, _hoisted_24),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary",
              disabled: _ctx.closed || _ctx.points.length < 3,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeRegion && _ctx.closeRegion(...args)))
            }, " Fechar área ", 8, _hoisted_25),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-dark",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectFullFrame && _ctx.selectFullFrame(...args)))
            }, " Usar quadro inteiro ")
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            disabled: !_ctx.canSave || _ctx.saving,
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveRegion && _ctx.saveRegion(...args)))
          }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar perímetro'), 9, _hoisted_28)
        ])
      ])
    ])
  ], 512))
}